// extracted by mini-css-extract-plugin
export default {"main":"HeaderAccount_main__Blbz1","container":"HeaderAccount_container__dcoIt","menu":"HeaderAccount_menu__-bs4c","message":"HeaderAccount_message__JjN7O"};